import { Inject, Pipe, PipeTransform } from '@angular/core';
import { Balance, Money } from 'mbs-ui-shared@components/components/models/license.model';
import { BALANCE_TOKEN } from 'mbs-ui-shared@components/licenses/tokens/balance.token';
import { getPostPaymentPrice } from 'mbs-ui-shared@components/licenses/utils/price.util';
import { Observable, of, switchMap } from 'rxjs';

@Pipe({ name: 'price' })
export class PricePipe implements PipeTransform {
  constructor(@Inject(BALANCE_TOKEN) public balance: Observable<Balance>) {}

  transform(value: Money | string | number, period?: string): Observable<string> {
    return this.balance.pipe(switchMap((balance) => of(getPostPaymentPrice(balance, value, period))));
  }
}
